export default "__VITE_ASSET__BcwRxKcl__"